// extracted by mini-css-extract-plugin
export default {"component":"ReviewsList__component-OQaf"};